import {atom} from 'recoil';
import {recoilPersist} from 'recoil-persist';

const {persistAtom} = recoilPersist();
export const verifyInfoState = atom({
    key: 'verifyInfoState',
    default: {}, effects_UNSTABLE: [persistAtom],
});